import { type Pinia } from "pinia";
import { createTRPCNuxtClient, httpBatchLink, httpLink } from "trpc-nuxt/client";

import { type AppRouter } from "~/server/trpc/routers";
import { useLanguageStore } from "~/stores/language";
import { languageToLocale } from "~/utils/language";

export default defineNuxtPlugin(({ $pinia }) => {
  const httpRequestMethod = process.env.NODE_ENV === "production" ? httpBatchLink : httpLink;

  const languageStore = useLanguageStore();
  const config = useRuntimeConfig();

  /**
   * createTRPCNuxtClient adds a `useQuery` composable
   * built on top of `useAsyncData`.
   */
  const client = createTRPCNuxtClient<AppRouter>({
    links: [
      httpRequestMethod({
        url: "/api/trpc",

        /**
         * Headers will be called on each request.
         */
        headers() {
          return {
            "x-tenant-id": config.public.motocommerce.tenantId,
            "accept-language": languageToLocale[languageStore.language],
          };
        },
      }),
    ],
  });

  ($pinia as Pinia).use(() => ({ $client: client }));

  return {
    provide: {
      client,
    },
  };
});
